export default "__VITE_ASSET__BGHatS86__"